const rootKey = '/operational-cost';

export const saveOperationalCost = () => {
  return `${rootKey}`;
};
